import React, { useEffect } from "react";
import style from "./index.module.scss";
import AMapLoader from '@amap/amap-jsapi-loader';

const MapContainer = () => {
  let map = null;

  useEffect(() => {
    window._AMapSecurityConfig = {
      securityJsCode: "810423c5aab6410ce510780e24ed4f09",
    };
    AMapLoader.load({
      key: "2766042497d070faf631476bd6ae5d98", // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ["AMap.Scale"], //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
    })
      .then((AMap) => {
        map = new AMap.Map("container", {
          // 设置地图容器id
          viewMode: "3D", // 是否为3D地图模式
          zoom: 18, // 初始化地图级别
          center: [114.057127, 22.534164], // 初始化地图中心点位置
        });
        const marker = new AMap.Marker({
          position: [114.057127, 22.534164], //位置
        });
        map.add(marker); //添加到地图
      })
      .catch((e) => {
        console.log(e);
      });

    return () => {
      map?.destroy();
    };
  }, []);

  return (
    <div
      id="container"
      className={style.container}
    ></div>
  );
};

export default MapContainer;
